export default function AccessDenied() {
  return (
    <div className="error-page">
      <img src={'/img/logo.svg'} alt="Bellcorp" />
      <h2>Access Denied</h2>
      <a href="/" className="btn btn-primary mt-3">
        <i className="fas fa-chevron-left"></i> Take me back to WMS
      </a>
    </div>
  );
}
